/* CustomFieldForm.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtko8HPE%7Bpadding-block-end%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNO7dHp%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bHrqEAEMG%7Bflex-basis%3A0%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._43nrzTdnbC%7Bmargin-block-start%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL4NHnM%7Bpadding-inline%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuI7V3%7Bjustify-content%3Aspace-between%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0rIjyk8HPE%7Bmargin-block-end%3Avar(--ds-space-150%2C9pt)%7D");
import React from 'react';
import { Checkbox } from '@atlaskit/checkbox/checkbox';
import { ErrorMessage } from '@atlaskit/form/error-message';
import Field from '@atlaskit/form/field';
import Form from '@atlaskit/form/form';
import { FormHeader } from '@atlaskit/form/form-header';
import { HelperMessage } from '@atlaskit/form/helper-message';
import { RequiredAsterisk } from '@atlaskit/form/required-asterisk';
import { useFormState } from '@atlaskit/form/use-form-state';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import Select from '@atlaskit/select/default';
import type { OptionType, ValueType } from '@atlaskit/select/types';
import TextArea from '@atlaskit/textarea/text-area';
import TextField from '@atlaskit/textfield/text-field';
import { defineMessage, useIntl } from 'react-intl';
import { fg } from '@townsquare/stat-sig/gate';
import type { CustomFieldFormProps, CustomFieldFormValues, FieldOption, StringOption, ValidationError } from '../types';
import { renderCustomFieldIcon } from '../utils';
import { CustomFieldFormFooter } from './CustomFieldFormFooter';
import { CustomFieldFormHeader } from './CustomFieldFormHeader';
import { FieldOptionsInput } from './FieldOptionsInput';
import { PeopleFormatSelect } from './PeopleFormatSelect';
import { TeamTypeScopeSelect } from './TeamTypeScopeSelect';
import { isCustomFieldFormValid } from './isCustomFieldFormValid';
const requiredFieldsSummaryMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.required-fields-summary',
  defaultMessage: 'Required fields are marked with an asterisk',
  description: 'Header text indicating required fields in the custom field form'
});
const nameLabelMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.name-label',
  defaultMessage: 'Name',
  description: 'Label shown above the name input field in the custom field creation or edit form.'
});
const nameHelperMessageMsg = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.name-helper-message',
  defaultMessage: 'Max length of 30 characters',
  description: 'Helper text shown beneath the name input in the custom field form, indicating the maximum allowed character count.'
});
const fieldTypeLabelMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-type-label',
  defaultMessage: 'Field type',
  description: 'Label shown above the field type dropdown in the custom field creation or edit form.'
});
const fieldTypeTriggerMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-type-trigger',
  defaultMessage: 'Select a field type',
  description: 'Trigger text for the custom field type dropdown'
});
const fieldTypeTextMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-type-text',
  defaultMessage: 'Text',
  description: 'Drop-down item label for the Text option in the field type selector of the custom field form.'
});
const fieldTypeDropdownMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-type-select',
  defaultMessage: 'Select',
  description: 'Drop-down item label for the Select option in the field type selector of the custom field form.'
});
const fieldTypePeopleMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-type-people',
  defaultMessage: 'People',
  description: 'Drop-down item label for the People option in the field type selector of the custom field form.'
});
const fieldTypeNumberMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-type-number',
  defaultMessage: 'Number',
  description: 'Drop-down item label for the Number option in the field type selector of the custom field form.'
});
const fieldTypeHelperMessageMsg = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-type-helper-message',
  defaultMessage: "You can't change the type after creating a field.",
  description: 'Helper text shown beneath the field type selector in the custom field form, warning that the type cannot be changed after creation.'
});
const fieldCardinalityLabelMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-cardinality-label',
  defaultMessage: 'Let users select multiple options',
  description: 'Label for the custom field cardinality checkbox'
});
const fieldOptionsLabelMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.field-options-label',
  defaultMessage: 'Options',
  description: 'Label shown above the list of selectable options in the custom field form when the field type is set to Select.'
});
const descriptionLabelMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.description-label',
  defaultMessage: 'Description',
  description: 'Label for the custom field description field'
});
const descriptionHelperMessageMsg = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.description-helper-message',
  defaultMessage: 'Users see this info when they hover over the field.',
  description: 'Helper text shown beneath the description input in the custom field form, explaining that users see it on hover.'
});
const nameTooLongErrorMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.name-too-long-error',
  defaultMessage: 'Must be 30 characters or less.',
  description: 'Error message when field name exceeds character limit'
});
const descriptionTooLongErrorMessage = defineMessage({
  id: 'townsquare.teams-settings.custom-field-form.description-too-long-error',
  defaultMessage: 'Must be 60 characters or less.',
  description: 'Error message when description exceeds character limit'
});
const styles = {
  formWrapper: "_0jFU0VN91d _0xmtko8HPE",
  formElement: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _43nrzTdnbC",
  formContainer: "_2Y7lL4NHnM _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0xmtko8HPE",
  formContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3",
  requiredFieldsSummary: "_0rIjyk8HPE"
};
type FormContentProps = {
  mode: 'create' | 'edit';
  onClose: () => void;
  isLoading?: boolean;
  initialValues?: Partial<CustomFieldFormValues>;
  scopeId?: string;
};
const FormContent = ({
  mode,
  onClose,
  isLoading,
  initialValues,
  scopeId
}: FormContentProps) => {
  const intl = useIntl();
  const formState = useFormState<CustomFieldFormValues>({
    values: true,
    errors: true
  });
  const fieldTypeOptions = [{
    label: intl.formatMessage(fieldTypeTextMessage),
    value: 'STRING',
    icon: renderCustomFieldIcon('STRING')
  }, {
    label: intl.formatMessage(fieldTypeDropdownMessage),
    value: 'SELECTOR',
    icon: renderCustomFieldIcon('SELECTOR')
  }, {
    label: intl.formatMessage(fieldTypePeopleMessage),
    value: 'USER',
    icon: renderCustomFieldIcon('USER')
  }, {
    label: intl.formatMessage(fieldTypeNumberMessage),
    value: 'NUMBER',
    icon: renderCustomFieldIcon('NUMBER')
  }];
  const resolvedFieldTypeDefault = initialValues?.fieldType ? (() => {
    const initialTypeValue = (initialValues.fieldType as StringOption)?.value;
    // TEAM is a sub-type of People (USER), so resolve it to the USER/People option
    const lookupValue = initialTypeValue === 'TEAM' ? 'USER' : initialTypeValue;
    const match = fieldTypeOptions.find(option => option.value === lookupValue);
    return match ? {
      label: match.label,
      value: match.value
    } : null;
  })() : null;
  const fieldTypeValue = formState?.values?.fieldType ?? resolvedFieldTypeDefault;
  const isPeopleType = fieldTypeValue?.value === 'USER';
  const shouldShowCardinalityField = fieldTypeValue?.value === 'SELECTOR' || isPeopleType;
  const isFormValid = isCustomFieldFormValid(formState);
  return <Box xcss={styles.formContainer}>
			<FormHeader>
				<Box xcss={styles.requiredFieldsSummary}>
					<Text size="small">{intl.formatMessage(requiredFieldsSummaryMessage)}</Text>
					<RequiredAsterisk />
				</Box>
			</FormHeader>
			<Box xcss={styles.formContent}>
				<Stack space="space.150">
					<Field name="fieldName" label={intl.formatMessage(nameLabelMessage)} isRequired defaultValue={initialValues?.fieldName ?? ''} validate={(value): ValidationError | undefined => {
          if (value && value.length > 30) {
            return 'NAME_TOO_LONG';
          }
        }}>
						{({
            fieldProps,
            error
          }) => {
            return <React.Fragment>
									<TextField autoComplete="off" {...fieldProps} />
									{error === 'NAME_TOO_LONG' && ( /* eslint-disable-next-line @atlaskit/design-system/use-field-message-wrapper -- TODO: migrate to MessageWrapper */
              <ErrorMessage>{intl.formatMessage(nameTooLongErrorMessage)}</ErrorMessage>)}
									{!error && ( /* eslint-disable-next-line @atlaskit/design-system/use-field-message-wrapper -- TODO: migrate to MessageWrapper */
              <HelperMessage>{intl.formatMessage(nameHelperMessageMsg)}</HelperMessage>)}
								</React.Fragment>;
          }}
					</Field>
					<Field<ValueType<OptionType>> name="fieldType" label={intl.formatMessage(fieldTypeLabelMessage)} isRequired defaultValue={resolvedFieldTypeDefault}>
						{({
            fieldProps
          }) => <React.Fragment>
								<Select {...fieldProps} options={fieldTypeOptions} isDisabled={mode === 'edit'} placeholder={intl.formatMessage(fieldTypeTriggerMessage)} formatOptionLabel={(option, {
              context
            }) => <Inline space="space.100" alignBlock="center">
											{option.icon}
											<Text color={context === 'value' ? 'color.text.subtlest' : undefined}>
												{option.label}
											</Text>
										</Inline>} />
								{/* eslint-disable-next-line @atlaskit/design-system/use-field-message-wrapper -- TODO: migrate to MessageWrapper */}
								<HelperMessage>{intl.formatMessage(fieldTypeHelperMessageMsg)}</HelperMessage>
							</React.Fragment>}
					</Field>
					{fg('enable_team_type_scoped_custom_fields') && (mode === 'edit' || !!scopeId) && <TeamTypeScopeSelect mode={mode} scopeId={scopeId} initialValue={initialValues?.teamTypeScope} />}
					{isPeopleType && <PeopleFormatSelect mode={mode} initialValue={initialValues?.peopleFormat} />}
					{/* Temporary disabled number format select and currency select, since Backend not support yet */}
					{/* {formState?.values?.fieldType?.value === 'NUMBER' && (
      <>
      	<NumberFormatSelect mode={mode} />
      	<CurrencySelect shouldShowCurrency={shouldShowCurrencyField} />
      </>
      )} */}
					{shouldShowCardinalityField && <Field name="fieldCardinality" defaultValue={initialValues?.fieldCardinality ?? false}>
							{({
            fieldProps
          }) => <Checkbox id={fieldProps.id} isChecked={fieldProps.value} isInvalid={fieldProps.isInvalid} isRequired={fieldProps.isRequired} onChange={e => fieldProps.onChange(e)} label={intl.formatMessage(fieldCardinalityLabelMessage)} isDisabled={mode === 'edit'} />}
						</Field>}
					{fieldTypeValue?.value === 'SELECTOR' && <Field<FieldOption[]> name="fieldOptions" label={intl.formatMessage(fieldOptionsLabelMessage)} isRequired defaultValue={initialValues?.fieldOptions ?? []} validate={(value): ValidationError | undefined => {
          if (!value || value.length === 0) {
            return 'NO_OPTIONS';
          }
        }}>
							{({
            fieldProps
          }) => <FieldOptionsInput value={fieldProps.value} onChange={options => fieldProps.onChange(options)} />}
						</Field>}
					<Field name="fieldDescription" label={intl.formatMessage(descriptionLabelMessage)} defaultValue={initialValues?.fieldDescription ?? ''} validate={(value): ValidationError | undefined => {
          if (value && value.length > 60) {
            return 'DESCRIPTION_TOO_LONG';
          }
        }}>
						{({
            fieldProps,
            error
          }) => {
            return <React.Fragment>
									<TextArea {...fieldProps} minimumRows={3} onChange={e => {
                const newValue = e.target.value;
                fieldProps.onChange(newValue);
              }} />
									{error === 'DESCRIPTION_TOO_LONG' && ( /* eslint-disable-next-line @atlaskit/design-system/use-field-message-wrapper -- TODO: migrate to MessageWrapper */
              <ErrorMessage>
											{intl.formatMessage(descriptionTooLongErrorMessage)}
										</ErrorMessage>)}
									{!error && ( /* eslint-disable-next-line @atlaskit/design-system/use-field-message-wrapper -- TODO: migrate to MessageWrapper */
              <HelperMessage>{intl.formatMessage(descriptionHelperMessageMsg)}</HelperMessage>)}
								</React.Fragment>;
          }}
					</Field>
				</Stack>
				<CustomFieldFormFooter mode={mode} onCancel={onClose} isFormValid={isFormValid} isLoading={isLoading} />
			</Box>
		</Box>;
};
export const CustomFieldForm = ({
  mode,
  onClose,
  onSubmit,
  initialValues,
  scopeId
}: CustomFieldFormProps): React.JSX.Element => {
  const [isLoading, setIsLoading] = React.useState(false);
  const handleSubmit = React.useCallback((values: CustomFieldFormValues) => {
    if (onSubmit) {
      setIsLoading(true);
      void onSubmit(values).finally(() => setIsLoading(false));
    }
  }, [onSubmit]);
  return <Stack space="space.200" xcss={styles.formWrapper}>
			<CustomFieldFormHeader mode={mode} onClose={onClose} />
			<Form<CustomFieldFormValues> onSubmit={handleSubmit}>
				{({
        formProps
      }) => <Box as="form" {...formProps} xcss={styles.formElement}>
						<FormContent mode={mode} onClose={onClose} isLoading={isLoading} initialValues={initialValues} scopeId={scopeId} />
					</Box>}
			</Form>
		</Stack>;
};